const awsconfig = {
  aws_project_region: 'us-east-2', // The region your project is deployed in
  // aws_cognito_identity_pool_id: 'us-east-2:29844316-8690-46e2-ac60-90d78bb60cbb',
  aws_cognito_region: 'us-east-2',
  aws_user_pools_id: 'us-east-2_9ZjxKZJ4v', // Your Cognito User Pool ID
  aws_user_pools_web_client_id: '7s54jcehmo01qvon7t0ujdtaag', // Your User Pool Web Client ID

   // Other Amplify settings as needed
   aws_cognito_username_attributes: ['EMAIL'],
   aws_cognito_signup_attributes: ['EMAIL', 'NAME', 'GIVEN_NAME', 'FAMILY_NAME'],
   aws_cognito_mfa_configuration: 'OFF',
   aws_cognito_password_protection_settings: {
     passwordPolicyMinLength: 8,
     passwordPolicyCharacters: []
   },
   aws_cognito_verification_mechanisms: ['EMAIL']
};

export default awsconfig;

